import { config } from 'config';
import type { Shelf } from './types';

const base = config.apiBaseUrl;

function getJson<T>(res: Response): Promise<T> {
  if (!res.ok) {
    return res.json().then(
      (body: { message?: string; code?: string }) => {
        throw new Error(body.message ?? `HTTP ${res.status}`);
      },
      () => {
        throw new Error(`HTTP ${res.status}`);
      }
    );
  }
  return res.json();
}

export async function searchShelves(query: string, limit?: number): Promise<Shelf[]> {
  const search = new URLSearchParams();
  search.set('q', query);
  if (limit != null) search.set('limit', String(limit));
  const res = await fetch(`${base}/shelves/search?${search.toString()}`, { credentials: 'include' });
  return getJson<Shelf[]>(res);
}

export async function createShelf(name: string): Promise<Shelf> {
  const res = await fetch(`${base}/shelves`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({ name }),
  });
  return getJson<Shelf>(res);
}
